import { Button, Modal, Typography } from '@volvo/vcdk-react';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import sampleQrCode from '@/assets/qr-code-sample.webp';
import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type Props = {
  campaignTitle: string;
};

const QRCode = ({ size = 120 }) => {
  return <img src={sampleQrCode} alt="QR code for Volvo Penta Connect app" width={size} height={size} />;
};

const SoftwareInstallationAvailableModal: React.FC<Props> = ({ campaignTitle }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Button variant="secondary" iconStart="info" onClick={() => setIsOpen(true)}>
        Installation
      </Button>
      {isOpen &&
        createPortal(
          <Modal open={isOpen} onClose={() => setIsOpen(false)} width={600} maxWidth="90%">
            <span slot="header">Software installation available</span>
            <section className="mb-6 flex flex-col gap-6">
              <Typography>
                {campaignTitle} is available for installation on one or several of your units. To begin the installation
                process, please ensure that you have the Volvo Penta Connect application installed on your mobile phone.
              </Typography>
              {/* QR Code Section */}
              <div className="flex justify-center py-8">
                <QRCode size={160} />
              </div>
              <Typography>Scan to access the application on your mobile device or read more on</Typography>
            </section>
            <span slot="footer">
              <div className="flex gap-4">
                <Button
                  href="https://apps.apple.com/us/app/volvo-penta-connect/id6469306435"
                  iconEnd="link-external"
                  target="_blank"
                  variant="tertiary"
                  rel="noreferrer"
                >
                  App store
                </Button>
                <Button
                  href="https://play.google.com/store/apps/details?id=com.volvopenta.pentaconnect"
                  iconEnd="link-external"
                  target="_blank"
                  variant="tertiary"
                  rel="noreferrer"
                >
                  Google Play
                </Button>
              </div>
            </span>
          </Modal>,
          document.body
        )}
    </>
  );
};

export default withComponentErrorBoundary(SoftwareInstallationAvailableModal);
